import { LayoutGamesMainWebView } from "@/components/webview/games/layout/LayoutGamesMainWebView";
import GamesBannerWebView from "@/components/webview/games/core/GamesBannerWebView";
import { Button } from "@/v2-components/ui/button";
import { Button2 } from "@/components/webview/games/typograpy/typograpy-webview";
import React from "react";
import { useTrans } from "@/utils/useTrans";
import { GamesWrapLazyContentsWebView } from "@/components/webview/games/GamesWrapLazyContentsWebView";
import SteamVrLazySectionsWebView from "@/components/webview/games/main/SteamVrLazySectionsWebView";
import { openBrowserWebView } from "@/components/webview/utils/webViewBridge";

export const SteamVrWebView = () => {
  const { t } = useTrans(["games"]);

  return (
    <LayoutGamesMainWebView
      bannerImg={"/images/games/banners/steam-vr-mobile@3x.jpg"}
      bannerContents={
        <>
          <GamesBannerWebView.Title
            text={t(`Full-Body Haptics for SteamVR Games`)}
          />
          <GamesBannerWebView.Description
            text={t(
              `Experience every shot, explosion, and impact with bHaptics-supported SteamVR titles.`,
            )}
          />
          <div className="mt-6 flex w-full flex-col gap-2 laptop:mt-8 laptop:flex-row">
            <Button
              size="sm"
              variant="darkgray-outline"
              shape="pill"
              className="bg-transparent px-6 laptop:text-blue-60 laptop:outline-blue-60 laptop:hover:bg-blue-60 laptop:hover:text-white"
              onClick={() => {
                openBrowserWebView({
                  url: "support/help/?categorySlug=software-pc-player-for-windows-install-and-set-up",
                });
              }}
            >
              <Button2>{t("Getting Started", { ns: "gnb" })}</Button2>
            </Button>
            <Button
              size="sm"
              variant="darkgray-fill"
              shape="pill"
              className="bg-black px-6 text-white focus-visible:outline-none"
              onClick={() => {
                openBrowserWebView({
                  url: "games/pc/software/",
                });
              }}
            >
              <Button2>{t("bHaptics Player for PC")}</Button2>
            </Button>
          </div>
        </>
      }
    >
      {/* lazy 하게 게임컴포넌트를 가져옵니다 */}
      <GamesWrapLazyContentsWebView contents={<SteamVrLazySectionsWebView />} />
    </LayoutGamesMainWebView>
  );
};
